import { PrimaryButton } from 'src/shared/design-system/Buttons';
import { ChevronLeftV2, Search } from 'src/shared/design-system/Icon';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const BackButtonIcon = ChevronLeftV2;

export const BackButton = styled.button`
  background: none;
  border: ${Border.Base} ${Colors.GRAY_LITE_10};
  padding: ${Spacing.QUARTER};
  transform: translateX(${Spacing.SINGLE});
  z-index: 10;
  ${Mixins.Flex.center()}
  ${Mixins.Shape.circleForcedMinDimensions(Spacing.SINGLE_HALF)}
`;

export const SearchInputWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const SearchIcon = styled(Search)`
  ${Mixins.Shape.squareForcedMinDimensions(Spacing.SINGLE_HALF)}
`;

export const SearchButton = styled(PrimaryButton)<{ disabled: boolean }>`
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  margin: 0;
  padding: 0;
  height: ${Spacing.DOUBLE};
  width: ${Spacing.DOUBLE_HALF};

  ${ifProp(
    'disabled',
    css`
      color: ${Colors.GRAY_DARK_20};
    `
  )}

  ${Mixins.Media.maxWidthSmall(css`
    display: none;
  `)}
`;

export const InputContainer = styled.div`
  ${Mixins.Flex.center()}
  flex: 1 1 100%;
  background: ${Colors.GRAY_LITE_20};
  height: 100%;
  border-radius: ${Border.Radius.M};
  padding: 0;
  gap: ${Spacing.QUARTER};

  ${Mixins.Media.maxWidthSmall(css`
    background: ${Colors.WHITE};
  `)}

  & + ${SearchButton} {
    ${Mixins.Border.flattenLeftSide()}
  }
`;

export const Container = styled.div<{ isOpen?: boolean }>`
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.NORMAL};
  height: ${Spacing.DOUBLE};
  background-color: ${Colors.WHITE};
  transition: max-width ${Transition.Time.BASE}, width ${Transition.Time.BASE};
  ${Mixins.Flex.set()}

  ${Mixins.Media.maxWidthSmall(css`
    transition: none;
  `)}

  ${({ isOpen }) => {
    if (isOpen) {
      return css`
        width: calc(100vw - 400px);
        max-width: 1000px;

        & ${BackButton} {
          display: none;
        }

        ${Mixins.Media.maxWidthSmall(css`
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: ${Spacing.TRIPLE_HALF};
          border-bottom: ${Border.Base} ${Colors.GRAY_LITE_20};

          & input {
            padding-left: ${Spacing.SINGLE_HALF};
            font-size: ${Font.Size.S};
          }

          & ${SearchIcon} {
            display: none;
          }

          & ${BackButton} {
            display: flex;
          }
        `)}
      `;
    }
    return css`
      width: 270px;
      max-width: 270px;

      & ${BackButton} {
        display: none;
      }

      ${Mixins.Media.maxWidthSmall(css`
        padding: 0;
        width: ${Spacing.DOUBLE};

        & input {
          cursor: pointer;
          caret-color: transparent;
          font-size: ${Font.Size.S};
        }

        & ${SearchInputWrapper} button {
          display: none;
        }
      `)}
    `;
  }}
`;
